// ============================================================
// Plan import from a photo or PDF (#69): helpers shared by the
// browser and the Worker's `plan-extract` AI task. The extracted rows
// become an ordinary pasted table, so mapping, validation and preview
// stay the same as for Excel/SAP. Plain JS: the Worker imports it.
// ============================================================

import { samplePlanTsv } from '../data/planImportSample.js';

export const PLAN_FIELDS = ['orderId', 'customer', 'material', 'weight', 'carrier', 'date', 'time', 'type'];
// Czech headers that autoMap() in planImport.js recognises.
const HEADERS = ['Dodávka', 'Zákazník', 'Materiál', 'Množství', 'Dopravce', 'Datum', 'Čas', 'Typ'];

export const rowsToTsv = (rows) =>
  [HEADERS, ...rows.map(r => PLAN_FIELDS.map(f => String(r[f] ?? '').replace(/\t|\n/g, ' ')))]
    .map(cells => cells.join('\t')).join('\n');

// Prepared answer without a key: the sample plan, as if read from the photo.
export function planExtractDemo() {
  const [, ...lines] = samplePlanTsv().split('\n');
  return {
    rows: lines.map(l => Object.fromEntries(l.split('\t').map((v, i) => [PLAN_FIELDS[i], v]))),
    notes: '',
  };
}

// File → { mediaType, data (base64 without prefix) } for the AI request.
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ mediaType: file.type, data: String(reader.result).split(',')[1] });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
